module.exports = __webpack_public_path__ + "img/intro1.c8647046.svg";